import type { DeclarationFieldError } from "../../state/declaration-submission-port";
import { ERROR_REGISTRY } from "../../validation/error-registry";
import type { DeclarationServerFieldErrors } from "./DeclarationRoute";

/** REQ-004 (PR 3814): one message per server `representativeName` reason, so "Enter the name of the
 * authorized representative" shows for a blank name only. */
const REPRESENTATIVE_NAME_MESSAGE_BY_REASON: ReadonlyMap<string, string> = new Map([
  ["required", ERROR_REGISTRY["declaration.representativeName"].missing],
  ["too_long", ERROR_REGISTRY["declaration.representativeName"].tooLong],
  ["control_characters", ERROR_REGISTRY["declaration.representativeName"].invalidCharacters],
]);

/** TG-4 (m1-declaration-next-steps), moved out of App.tsx for REQ-004: maps the submission write's
 * 422 `invalid_declaration` `fieldErrors` (`src/api/functions/submission.py`) onto screen 6's
 * error-registry strings. `representativeName` maps per reason; an unknown reason falls back to the
 * blank-name message, which still names the field. `agreed` (`must_be_true`) maps to the
 * acknowledgement message. */
export function toDeclarationServerFieldErrors(
  fieldErrors: readonly DeclarationFieldError[] | undefined,
): DeclarationServerFieldErrors | undefined {
  if (fieldErrors === undefined || fieldErrors.length === 0) {
    return undefined;
  }
  const result: DeclarationServerFieldErrors = {};
  for (const fieldError of fieldErrors) {
    if (fieldError.field === "representativeName") {
      result.representativeName =
        REPRESENTATIVE_NAME_MESSAGE_BY_REASON.get(fieldError.reason) ??
        ERROR_REGISTRY["declaration.representativeName"].missing;
    } else if (fieldError.field === "agreed") {
      result.acknowledgement = ERROR_REGISTRY["declaration.acknowledgement"].missing;
    }
  }
  return result;
}
